





































import { Project } from '@/model/Project';
import Vue, { PropType } from 'vue'
import moment from 'moment'

const DISPLAY_LIMIT = 6;

type Application = {
  applicationId: string;
  name: string;
  slug: string;
  reward: number | undefined;
  isFinished: boolean;
}

export default Vue.extend({
  name: 'ContestList',

  props: {
    project: {
      type: Object as PropType<Project>,
    },
  },

  data: () => ({
    isExpanded: false,
    displayLimit: DISPLAY_LIMIT,
  }),

  computed: {
    applications(): Application[] {
      this.parseApplication(this.project.contestApplications[0])
      const parsedApplications = this.project.contestApplications.map(this.parseApplication);
      const sortedApplications = parsedApplications.sort((a, b) => {
        if (a.reward && !b.reward) return -1;
        if (!a.reward && b.reward) return 1;

        if (!a.isFinished && b.isFinished) return -1;
        if (a.isFinished && !b.isFinished) return 1;

        if (a.isFinished && b.isFinished) return 0;

        return 0;
      });

      return this.isExpanded ? sortedApplications : sortedApplications.slice(0, DISPLAY_LIMIT);
    },
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    parseApplication(application: Project['contestApplications'][0]): Application {
      const contestPlace = this.project.contestPlaces.find((contestPlace) => contestPlace.contest['@id'] === application.contest['@id'])?.place;

      return {
        applicationId: application['@id'],
        name: application.contest.name,
        slug: application.contest.slug,
        reward: contestPlace,
        isFinished: moment(application.contest.endAt).isBefore(moment()),
      };
    },

    getClass(reward: number) {
      if (reward === 1) return 'gold';
      if (reward === 2) return 'silver';
      if (reward === 3) return 'bronze';

      return '';
    },
  }
})
